import { EventEmitter, Injectable, ComponentFactoryResolver, ViewContainerRef } from "@angular/core";
import { WhitelabelConfig } from "../_models/whitelabelConfig.model";
import { ApiService } from ".";
import * as _ from 'lodash';
import { WhitelabelFeature } from "../_models/whitelabelFeature.model";
import { environment } from "../../environments/environment";
import {Http, Response, RequestOptionsArgs, Headers, RequestOptions} from "@angular/http";
import {Observable} from "rxjs/Observable";
import 'rxjs/add/observable/forkJoin';

@Injectable()
export class ConfigService {
    public configs : any= {};

    constructor(private http: Http) {
        this.getAll().subscribe(r=>{
            this.configs = r;
            console.log(r);
        });
    }

    public getAll(){
        return this.http.get(environment.apiBaseUrl +'/api/config' )
        .map((response : Response) => {
            return response.json();
        })
    }

 
}




// WEBPACK FOOTER //
// ./src/app/_services/config.service.ts